import { CALCULATOR_ENDPOINTS } from '@app/configs/api/calculator';
import { publicBaseApi } from './publicBaseApi';
export const publicCalculatorApi = publicBaseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPublicCalculatorOffering: builder.query({
            query: () => ({
                url: CALCULATOR_ENDPOINTS.offering,
            }),
            transformResponse: (response) => response.loanOfferings,
        }),
        getPublicCalculations: builder.query({
            query: ({ amount, period }) => ({
                url: CALCULATOR_ENDPOINTS.calculate,
                params: { amount, period },
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetPublicCalculatorOfferingQuery, useGetPublicCalculationsQuery } = publicCalculatorApi;
